module.exports = __webpack_public_path__ + "static/media/1 44 kanskje.c1e6d32b.mp3";